import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-booking-details',
    templateUrl: './booking-details.component.html',
    styleUrls: ['./booking-details.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        FlexModule,
        MatDividerModule,
        NgFor,
        DatePipe,
        TranslateModule,
    ],
})
export class BookingDetailsViewerComponent implements OnInit {
    constructor() {}

    //service item data
    @Input() serviceData;
    @Input() dateType;
    @Input() timeType;


    ngOnInit(): void {

    }

}
